module.exports = __webpack_public_path__ + "img/dp-sy-lm5.7450615c.png";